module.exports = __webpack_public_path__ + "media/4x3/sk-b84444bf.svg";